const SPECIAL_QUERY_STRING = ['clienttype=amp'];

const removeQueryInUrl = (pathname) => {
  const [url, queryString] = pathname.split('?');
  if (SPECIAL_QUERY_STRING.indexOf(queryString) >= 0) {
    pathname = url;
  }

  return pathname;

}

const buildURLFingerprinting = ({ url = '', lastEditedDate = '', queryStr = '?' }) => {
  const time = new Date(lastEditedDate).getTime();

  return time ? `${url}${queryStr}lastEditedDate=${time}` : url;
};

export { buildURLFingerprinting, removeQueryInUrl };



// WEBPACK FOOTER //
// ./shared/utils/UrlUtils.js